import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import GreenHeroShape from "../assets/green-hero-shape";
import Underline from "../assets/underline";
import YellowHeroShape from "../assets/yellow-hero-shape";
import YoutubeRed from "../assets/youtube";

const Hero = () => {
  return (
    <StyledHero className="font-inter">
      <div className="hero-wrapper">
        <div className="green-shape">
          <GreenHeroShape />
        </div>
        <div className="yellow-shape">
          <YellowHeroShape />
        </div>
        <h2>
          Find the perfect fit for your team on{" "}
          <span className="profiles-text">
            Profiles
            <span className="underline-img">
              <Underline />
            </span>
          </span>
          !
        </h2>
        <div className="hero-videos">
          <div className="youtube-vid">
            <iframe
              width="100%"
              height="100%"
              id="player"
              src="https://www.youtube.com/embed/rLqYhe6A71Q?modestbranding=1&amp;rel=0"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="vid-thumbnails">
            <div className="thumbnail-wrapper">
              <Link
                to={{ pathname: `/devlist` }}
                className="thumbnail-img"
              >
                <img
                  src="/images/ahmed_thumbnail.jpeg"
                  alt=".Net Engineer"
                  width={223}
                  height={119}
                />
                <div className="youtube-icon">
                  <YoutubeRed />
                </div>
              </Link>
              <div className="thumbnail-bio">
                <h4>Ahmed Ajala</h4>
                <p>C#/.Net</p>
                <p>Lagos, Nigeria</p>
              </div>
            </div>
            <div className="thumbnail-wrapper">
              <Link
                to={{ pathname: `/devlist` }}
                className="thumbnail-img"
              >
                <img
                  src="/images/chidera_nze.jpg"
                  alt="C#/.Net Engineer"
                  width={223}
                  height={119}
                />
                <div className="youtube-icon">
                  <YoutubeRed />
                </div>
              </Link>
              <div className="thumbnail-bio">
                <h4>Chidera Nze</h4>
                <p>Java/Springboot</p>
                <p>Lagos, Nigeria</p>
              </div>
            </div>
            <div className="thumbnail-wrapper">
              <Link
                to={{ pathname: `/devlist` }}
                className="thumbnail-img"
              >
                <img
                  src="/images/sofiyyah_abidoye.jpg"
                  alt="Javascript/Node"
                  width={223}
                  height={119}
                />
                <div className="youtube-icon">
                  <YoutubeRed />
                </div>
              </Link>
              <div className="thumbnail-bio">
                <h4>Sofiyyah Abidoye</h4>
                <p>Node/Javascript</p>
                <p>Lagos, Nigeria</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="view-profile">
        <Link to={"/devlist"} className="">
          See more Profiles
        </Link>
      </div>
    </StyledHero>
  );
};

const StyledHero = styled.section`
  margin-top: 9.4rem;
  padding-top: 4rem;
  padding-bottom: 8rem;
  position: relative;
  width: 100%;

  .green-shape {
    position: absolute;
    left: 0;
    top: 3.6rem;
  }

  .yellow-shape {
    position: absolute;
    right: 0;
    top: 3.6rem;
  }

  .hero-wrapper {
  }

  .hero-wrapper h2 {
    text-align: center;
    width: 650px;
    margin: 0 auto;
    font-size: 4.8rem;
    font-weight: 800;
  }

  .profiles-text {
    color: #34a853;
    position: relative;
  }

  .underline-img {
    position: absolute;
    left: 0;
    bottom: -28px;
  }

  .underline-img svg {
    width: 100%;
  }

  .hero-videos {
    display: grid;
    grid-template-columns: 2.2fr 1fr;
    gap: 16px;
    margin: 2.7rem auto 0 auto;
    padding: 3.2rem;
    background: #fff;
    box-shadow: 0px 21px 47px 0px rgba(71, 71, 71, 0.06),
      0px 86px 86px 0px rgba(71, 71, 71, 0.05),
      0px 193px 116px 0px rgba(71, 71, 71, 0.03),
      0px 344px 138px 0px rgba(71, 71, 71, 0.01),
      0px 537px 150px 0px rgba(71, 71, 71, 0);
    max-width: 1076px;
  }

  .hero-videos h4 {
    font-size: 1.4rem;
    font-weight: 600;
    white-space: nowrap;
    margin: 0;
  }

  .hero-videos p {
    font-size: 1.2rem;
    margin: 0;
    padding: 0;
  }

  .vid-thumbnails {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .thumbnail-wrapper {
    display: flex;
  }

  .thumbnail-img {
    width: 223px;
    height: 100%;
    background-color: rgba(16, 24, 40, 0.8);
    position: relative;
    cursor: pointer;
  }

  .youtube-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .thumbnail-img img {
    object-fit: cover;
    height: 100%;
    mix-blend-mode: overlay;
  }

  .thumbnail-bio {
    margin-left: 12px;
  }

  .view-profile {
    display: flex;
    justify-content: center;
    margin-top: 2.4rem;
  }

  .view-profile a {
    font-family: "Inter", sans-serif;
    display: inline-block;
    text-align: center;
    background-color: #34a853;
    font-weight: 600;
    color: #ffffff;
    width: 26.3rem;
    padding: 1.6rem;
    border-radius: 10rem;
    transition: all 0.2s ease-in-out;
  }
  .view-profile a:hover {
    background-color: #2f8a4c;
    text-decoration: none;
  }
  .view-profile a:active {
    opacity: 0.8;
  }

  @media screen and (max-width: 1150px) {
    .green-shape {
      display: none;
    }

    .yellow-shape {
      display: none;
    }

    .hero-videos {
      padding: 1.6rem;
    }
  }

  @media screen and (max-width: 850px) {
    .youtube-vid {
      height: 40rem;
    }

    .hero-videos {
      display: grid;
      grid-template-columns: 1fr;
      gap: 24px;
      margin: 2.7rem auto 0 auto;
    }

    .thumbnail-wrapper {
      flex-direction: column;
    }

    .thumbnail-img {
      width: 100%;
      height: 160px;
      background-color: rgba(16, 24, 40, 0.8);
      position: relative;
      cursor: pointer;
    }

    .thumbnail-img img {
      object-position: top;
    }

    .thumbnail-bio {
      margin-left: 0px;
      margin-top: 6px;
    }

    .vid-thumbnails {
      gap: 12px;
    }

    .hero-wrapper h2 {
      text-align: center;
      width: 100%;
      margin: 0 auto;
      font-size: 3.8rem;
      font-weight: 800;
    }
  }

  @media screen and (max-width: 600px) {
    margin-top: 64px;
    padding-top: 3.2rem;
    padding-bottom: 4rem;
    
    .hero-videos {
      padding: 1.6rem;
    }

    .underline-img {
      bottom: -16px;
    }

    .hero-wrapper h2 {
      font-size: 2.4rem;
      padding: 0 3.2rem;
      text-align: center;
    }

    .view-profile a {
      width: 100%;
      margin: 0 1.6rem;
    }
  }
`;

export default Hero;
